import { SliceHealthStatus } from '@ui/__generated__/graphql'
import { BrowserCodeIcon } from '@ui/components/icons'
import clsx from 'clsx'

interface StackedOutputProps {
  outputSize: string
  outputStatus: {
    logs: {
      style: string
      status: SliceHealthStatus
    }
    spans: {
      style: string
      status: SliceHealthStatus
    }
    metrics: {
      style: string
      status: SliceHealthStatus
    }
  }
  sources?: string[]
}

export const StackedOutput = ({ outputSize, outputStatus, sources }: StackedOutputProps) => {
  // If any of the outputStatus is not healthy, return the first unhealthy status
  const outputStatuses = Object.values(outputStatus)
  const unhealthyStatus = outputStatuses.find((output) => output.status === SliceHealthStatus.Failed)

  return (
    <div className="flex flex-col items-center divide-y divide-gray-400">
      {/* Output */}
      <div className="flex w-full flex-row items-center justify-start border-t border-gray-400 px-2.5 py-1 opacity-0">
        <BrowserCodeIcon className="mr-1 h-2.5 w-2.5" color="text-gray-600" />
        <p className="text-3xs font-medium text-gray-900">{outputSize} output</p>
      </div>
      {sources && sources.length > 0 && (
        <div className="flex w-full flex-row items-center justify-start border-gray-200 px-2.5 py-1 opacity-0">
          <BrowserCodeIcon className="mr-1 h-2.5 w-2.5" color="text-gray-600" />
          <p className="truncate text-3xs font-medium text-gray-900">{sources.join(', ')}</p>
        </div>
      )}
      <div className="flex w-full flex-row items-center justify-start border-gray-200 px-2.5 py-1">
        <div
          className={clsx('mr-1 h-2 w-2 rounded-full', {
            'bg-red-500': unhealthyStatus,
            'bg-green-500': !unhealthyStatus,
          })}
        />
        <p className="text-3xs font-medium text-gray-900">{unhealthyStatus ? 'Disabled' : 'Enabled'}</p>
      </div>
    </div>
  )
}
